// extracted by mini-css-extract-plugin
export default {"imageContainerStyles":"styles_imageContainerStyles__GJxo3","imageStyles":"styles_imageStyles__8qVG8"};